import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "w-full py-6 mx-auto" }
const _hoisted_2 = { class: "flex flex-col items-start justify-between xs:flex-row" }
const _hoisted_3 = { class: "md:mt-4 mt-6 flex items-start md:space-x-2.5 md:flex-row flex-col md:space-y-0 space-y-6" }
const _hoisted_4 = { class: "md:w-[600px] w-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Log-in", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Log-out", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Add New Patient", -1)
const _hoisted_8 = { class: "flex items-center md:space-x-2.5 md:flex-row flex-col md:space-y-0 space-y-6 md:mt-0 mt-6" }
const _hoisted_9 = { class: "w-full" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Filter", -1)
const _hoisted_11 = { class: "space-y-5" }
const _hoisted_12 = { class: "py-6" }
const _hoisted_13 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_14 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_15 = { class: "px-6 py-6 text-sm text-center text-gray-900 whitespace-nowrap" }
const _hoisted_16 = { class: "px-6 py-6 text-sm text-center text-gray-900 whitespace-nowrap" }
const _hoisted_17 = { class: "w-full px-6 border-t py-7" }
const _hoisted_18 = {
  key: 0,
  class: "text-[12px] mt-1 text-red-600 mb-2",
  id: "error-message"
}
const _hoisted_19 = { class: "flex items-center justify-center space-x-3 text-left" }
const _hoisted_20 = { class: "flex items-center justify-center space-x-3 text-left" }

import { ref, computed, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import UserLayout from "@/layouts/UserLayout.vue";
import SectionTitle from "@/components/partials/SectionTitle.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import FilterPanel from "@/components/partials/FilterPanel.vue";
import DataTable from "@/components/partials/DataTable.vue";
import MinifyPagination from "@/components/partials/MinifyPagination.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import TimePicker from "@/components/inputs/TimePicker.vue";
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import ExportButton from "@/components/buttons/ExportButton.vue";
import TimeInModal from "./Components/TimeInModal.vue";
import TimeOutModal from "./Components/TimeOutModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import PatientLogService from "@/classes/Settings/PatientLogService";
import pickBy from "lodash/pickBy";
import { errorResponse } from "@/helpers/errorMessage";
import DateFormatter from "@/helpers/DateFormatter";
import http from "@/axios";

interface timeFormInterface {
	hours: number | null;
	minutes: number | null;
	seconds: number | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const showFilter = ref<boolean>(false);
const showTimeIn = ref<boolean>(false);
const showTimeInSuccess = ref<boolean>(false);
const showTimeOut = ref<boolean>(false);
const showTimeOutSuccess = ref<boolean>(false);
const items = ref<any>(null);
const page = ref<any>(route.query.page);
const lastPage = ref<any>(null);
const rows = ref<any>(route.query.rows || 10);
const numRows = computed(() => (rows.value ? rows.value + " Rows" : "All"));
const filterDate = ref<any>(route.query.visit_date);
const currentDate = ref<Date>(new Date());
const is_logout = ref<boolean>(true);
const errors = ref<object | null>(null);
const timeIn = ref<Date>(new Date());
const timeOut = ref<Date>(new Date());
const patient = ref<number | null>(null);
const minDate = new Date();

const headers: { text: string; haveSort?: boolean }[] = [
	{ text: "Patient Name" },
	{ text: "Remarks" },
	{ text: "Time In", haveSort: true },
	{ text: "Time Out", haveSort: true },
];

const patientsOptions = ref<[]>([]);

const form = ref<{ patient_id: string; date: Date; time_in: string; time_out: string; remarks: string }>({
	patient_id: "",
	date: new Date(),
	time_in: "",
	time_out: "",
	remarks: "",
});

const resetForm = () => {
	form.value.patient_id = "";
	form.value.time_in = "";
	form.value.time_out = "";
	form.value.remarks = "";
	form.value.date = new Date();
};

const applyFilters = () => {
	resetForm();
	reloadPage().then(() => {
		showFilter.value = false;
		getData();
	});
};

const applyReset = () => {
	filterDate.value = "";
	reloadPage().then(() => {
		getData();
		showFilter.value = false;
	});
};

const changeRows = (row: any): void => {
	rows.value = row;
	applyFilters();
};

const paginate = (data: number): void => {
	page.value = data;
	applyFilters();
};

const reloadPage = async () => {
    if (filterDate.value) {
        filterDate.value = filterDate.value?.map((item: string) => {
            const date = new Date(item);
            return date.toISOString();
        });
    }
	return await router.push({
		path: "/patient-logs/index",
		query: pickBy({
			visit_date: filterDate.value,
			page: page.value,
			rows: rows.value,
		}),
	});
};

const getData = (patientId: number = null, hasDefaultPatients = false) => {
	PatientLogService.index({
		visit_date: filterDate.value,
		patient_id: patientId,
		page: page.value,
		rows: rows.value,
	})
		.then((response: object) => {
			items.value = response.data.items.data;
			page.value = response.data.items.current_page;
			lastPage.value = response.data.items.last_page;

            if (hasDefaultPatients) {
                patientsOptions.value = response.data.patients;
            }

			if (patientId) {
				PatientLogService.checkStatus({
					patient: patientId,
				})
					.then((response: object) => {
						is_logout.value = response.data.is_logout;
                        form.value.remarks = response.data.is_logout ? null : response.data.remarks;
					})
					.catch((error: object) => {
						is_logout.value = false;
						console.log(error);
					});
			}
		})
		.catch((error: any) => console.log(error));
};

const handlePatientSearch = async (value: string = null) => {

    if (!value && patient.value) {

        const response = await http.get(`/patient-logs/${patient.value}/patient`);
        console.log(response);

        return;
    }

    const response = await http.get('/patient-logs/patients', { params: {
        search: value
    } });

    if (response.status === 200) {
        patientsOptions.value = response.data;
    }
}

const redirect = (log = "timeIn") => {
	if (log == "timeIn") {
		showTimeInSuccess.value = false;
	} else {
		showTimeOutSuccess.value = false;
	}
	getData(form.value.patient_id);
};

const login = () => {
	PatientLogService.login(
		{
			patient: form.value.patient_id,
		},
		form.value
	)
		.then((response: object) => {
			showTimeInSuccess.value = true;
			showTimeIn.value = false;
			console.log(response);
		})
		.catch((error: object) => (errors.value = errorResponse(error.response?.data?.errors)));
};

const logout = () => {
	PatientLogService.logout(
		{
			patient: form.value.patient_id,
		},
		form.value
	)
		.then((response: object) => {
			showTimeOutSuccess.value = true;
			showTimeOut.value = false;
            form.value.remarks = null;
		})
		.catch((error: object) => (errors.value = errorResponse(error.response?.data?.errors)));
};

const selectedPatient = (patient:number) => {
	getData(patient);
	form.value.patient_id = patient;
}

const setTime = (data:any):void => {
	form.value.date.setHours(data.hours);
	form.value.date.setMinutes(data.minutes);
	form.value.date.setSeconds(data.seconds);
	console.log(form.value)
} 

const showLogin = () => {
    errors.value = {};
    showTimeIn.value = true
}

const showLogout = () => {
    errors.value = {};
    showTimeOut.value = true
}

onMounted(() => getData(null, true));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SectionTitle, {
            title: "Patient Logs",
            description: "View the relevant data and other details"
          })
        ]),
        _createElementVNode("form", _hoisted_3, [
          _createVNode(DatePicker, {
            disabled: true,
            enableTimePicker: true,
            id: "date_time_in",
            name: "date_time_in",
            label: "Date & Time In",
            modelValue: currentDate.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentDate).value = $event)),
            class: "w-full md:w-auto"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(MultiSelect, {
              options: patientsOptions.value,
              id: "patient_name",
              name: "patient_name",
              label: "Patient Name",
              placeholder: "Select..",
              searchable: "",
              modelValue: patient.value,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((patient).value = $event)),
                _cache[2] || (_cache[2] = (value) => (selectedPatient(value)))
              ],
              "onHandle:search": handlePatientSearch
            }, null, 8, ["options", "modelValue"])
          ]),
          (form.value.patient_id)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (is_logout.value)
                  ? (_openBlock(), _createBlock(ButtonComponent, {
                      key: 0,
                      onClick: showLogin,
                      style: {"margin-top":"24px !important"},
                      customClass: "bg-green-600 hover:bg-green-700 text-white transition border border-green-600 hover:border-green-700 py-[14px] shrink-0 md:w-auto w-full"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!is_logout.value)
                  ? (_openBlock(), _createBlock(ButtonComponent, {
                      key: 1,
                      onClick: showLogout,
                      style: {"margin-top":"24px !important"},
                      customClass: "bg-red-600 hover:bg-red-700 text-white transition border border-red-600 hover:border-red-700 py-[14px] shrink-0 md:w-auto w-full"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(ButtonComponent, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push('/patient/create'))),
            style: {"margin-top":"24px !important"},
            customClass: "bg-gray-600 hover:bg-gray-700 text-white transition border py-[14px] shrink-0 md:w-auto w-full"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(TextInput, {
              textarea: "",
              label: "Remarks",
              placeholder: "Remarks",
              name: "remarks",
              id: "remarks",
              textAreaRows: 1,
              modelValue: form.value.remarks,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.remarks) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(ButtonComponent, {
            btnWidth: "py-[14px] mt-6 md:w-[120px] w-full",
            style: {"margin-top":"24px !important"},
            onClick: _cache[5] || (_cache[5] = ($event: any) => (showFilter.value = true))
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ]),
        _createVNode(FilterPanel, {
          show: showFilter.value,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (showFilter.value = false)),
          "onApply:reset": _cache[8] || (_cache[8] = ($event: any) => (applyReset())),
          "onApply:filters": _cache[9] || (_cache[9] = ($event: any) => (applyFilters())),
          customClass: "!overflow-visible overflow-x-visible"
        }, {
          fields: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(DatePicker, {
                id: "visit_dates",
                name: "visit_dates",
                label: "Visit Dates",
                range: true,
                class: "filter-range",
                multiCalendars: "",
                modelValue: filterDate.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filterDate).value = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["show"]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(DataTable, {
            headers: headers,
            "no-action": true,
            count: items.value?.length,
            "onUpdate:searchText": _cache[12] || (_cache[12] = (value) => (_ctx.filterSearch = value)),
            tableClass: "header-frm-table three four"
          }, {
            body: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                return (_openBlock(), _createElementBlock("tr", { key: item }, [
                  _createElementVNode("td", _hoisted_13, _toDisplayString(item.patient?.name), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(item.remarks), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(DateFormatter).customDateFormat(item.time_in, 'MMM dd, yyy - hh:mm a ')), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(item.time_out ? _unref(DateFormatter).customDateFormat(item.time_out, 'MMM dd, yyy - hh:mm a ') : "-"), 1)
                ]))
              }), 128))
            ]),
            tfoot: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(MinifyPagination, {
                  numRows: numRows.value,
                  "onUpdate:rows": _cache[10] || (_cache[10] = (value) => changeRows(value)),
                  "onUpdate:page": _cache[11] || (_cache[11] = (value) => paginate(value)),
                  "current-page": page.value,
                  "last-page": lastPage.value
                }, null, 8, ["numRows", "current-page", "last-page"])
              ])
            ]),
            _: 1
          }, 8, ["count"])
        ])
      ]),
      _createVNode(TimeInModal, {
        show: showTimeIn.value,
        onCancel: _cache[16] || (_cache[16] = ($event: any) => (showTimeIn.value = false)),
        onConfirm: _cache[17] || (_cache[17] = ($event: any) => (login())),
        "cancel-text": "Cancel",
        "action-text": "Log-in",
        content: "Are you sure you wish to save this record?"
      }, {
        fields: _withCtx(() => [
          (errors.value?.message)
            ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(errors.value?.message), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(DatePicker, {
              id: "time_in_date",
              name: "time_in_date",
              label: "Date",
              class: "patient-logs-date",
              modelValue: form.value.date,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.date) = $event)),
              error: errors.value?.date,
              minDate: _unref(minDate)
            }, null, 8, ["modelValue", "error", "minDate"]),
            _createVNode(TimePicker, {
              disabled: !form.value.date,
              id: "time_in_time",
              name: "time_in_time",
              label: "Time",
              class: "patient-logs-date",
              placeholder: "HH:MM",
              timePicker: "",
              enableTimePicker: "",
              modelValue: timeIn.value,
              "onUpdate:modelValue": [
                _cache[14] || (_cache[14] = ($event: any) => ((timeIn).value = $event)),
                _cache[15] || (_cache[15] = (value) => (setTime(value)))
              ],
              error: errors.value?.time_in,
              minDate: _unref(minDate)
            }, null, 8, ["disabled", "modelValue", "error", "minDate"])
          ])
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showTimeInSuccess.value,
        onConfirm: _cache[18] || (_cache[18] = ($event: any) => (redirect('timeIn'))),
        "action-text": "Close",
        title: "Patient Log Recorded!",
        content: "New patient log has been successfully saved"
      }, null, 8, ["show"]),
      _createVNode(TimeOutModal, {
        show: showTimeOut.value,
        onCancel: _cache[22] || (_cache[22] = ($event: any) => (showTimeOut.value = false)),
        onConfirm: _cache[23] || (_cache[23] = ($event: any) => (logout())),
        "cancel-text": "Cancel",
        "action-text": "Log-out",
        content: "Are you sure you wish to save this record?"
      }, {
        fields: _withCtx(() => [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(DatePicker, {
              id: "time_in_date",
              name: "time_in_date",
              label: "Date",
              class: "patient-logs-date",
              modelValue: form.value.date,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.value.date) = $event)),
              error: errors.value?.date,
              minDate: _unref(minDate)
            }, null, 8, ["modelValue", "error", "minDate"]),
            _createVNode(TimePicker, {
              id: "time_in_time",
              name: "time_in_time",
              label: "Time",
              class: "patient-logs-date",
              placeholder: "HH:MM",
              timePicker: "",
              enableTimePicker: "",
              modelValue: timeOut.value,
              "onUpdate:modelValue": [
                _cache[20] || (_cache[20] = ($event: any) => ((timeOut).value = $event)),
                _cache[21] || (_cache[21] = (value) => (setTime(value)))
              ],
              error: errors.value?.time_out,
              minDate: _unref(minDate)
            }, null, 8, ["modelValue", "error", "minDate"])
          ])
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showTimeOutSuccess.value,
        onConfirm: _cache[24] || (_cache[24] = ($event: any) => (redirect('timeOut'))),
        "action-text": "Close",
        title: "Patient Log Recorded!",
        content: "New patient log has been successfully saved"
      }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})